import NonceDbService from "./NonceDbService";
import VoiceGainAuthSvcApi from "../../apis/VoiceGainAuthSvcApi";

abstract class NonceService {
  public static clearNonces = NonceDbService.clearNonces;

  public static getNonce = () =>
    NonceDbService.getNonce((nonce: string) =>
      VoiceGainAuthSvcApi.refreshNonces(nonce)
        .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error("Error refreshing nonces");
          }
        })
        .then(responseBody => {
          return responseBody.nonces;
        })
    );

  public static saveNonces = NonceDbService.saveNonces;
}

export default NonceService;
